import NewsroomAssetsList, {
  NewsroomAssetsListProps,
} from "./NewsroomAssetsList";

export { NewsroomAssetsList, NewsroomAssetsListProps };

export default NewsroomAssetsList;
